import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
function NewGamesArea() {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [games, setGames] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0)
  let slider1, slider2;

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);

    // Fetch games (limit 10)
    const fetchGames = async () => {
      try {
        const { data } = await axios.get(
          `https://be-staging.obigin.com/content/games?type=downloadable&page=1`
        );
        setGames(data.data.data || []);
      } catch (error) {
        console.error("Failed to fetch games", error);
      }
    };

    fetchGames();
  }, [slider1, slider2]);

  return (
    <section id="android-games" className="gray-bg pt-40">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title title-style-three text-center">
              <h2>
                Android <span>GAMES</span>
              </h2>
              <p>
                Power‑packed native titles built for buttery‑smooth play,
                stunning 3D visuals and endless replayability.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-8 col-lg-12">
            <Slider
              className="released-game-active"
              asNavFor={nav2}
              ref={(slider) => (slider1 = slider)}
              arrows={false}
              autoplay={true}
              autoplaySpeed={3000}
            >
              {games.map((game) => (
                <div className="released-game-carousel">
                  <div className="released-game-item">
                    <div className="released-game-img">
                      <img
                        src={game.vertical_graphic}
                        style={{ height: 380, width: 350, objectFit: "cover" }}
                        alt=""
                      />
                    </div>
                    <div className="released-game-content">
                      <div className="released-game-rating">
                        <h5>Age Rating: </h5>
                        {game.ageRating}
                      </div>
                      <h4>{game.name}</h4>
                      <div className="released-game-list mb-15">
                        <ul>
                          <li>
                            <span>Category :</span>Android
                          </li>
                        </ul>
                      </div>
                      <p
                        style={{
                          height: "80px",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >{game.shortDescription}</p>
                      <a target='_blank' rel="noreferrer" href={game.link} className="btn btn-style-two">
                        Download Now
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div style={{ maxHeight: "25rem" }} className="col-xl-4 col-lg-12">
            <Slider
              className="released-game-nav"
              asNavFor={nav1}
              swipeToSlide={true}
              focusOnSelect={true}
              ref={(slider) => (slider2 = slider)}
              slidesToShow={3}
              vertical={true}
              arrows={false}
              autoplay={true}
              autoplaySpeed={3000}
              beforeChange={(_, next) => setActiveIndex(next)}
            >
              {games.map((game, index) => (
                <div key={index}
                  className={`released-game-nav-item ${index === activeIndex ? "active" : ""
                    }`}>
                  <img className=""
                    style={{ width: 345, height: 131 }}
                    src={game.graphic}
                    alt=""
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewGamesArea;
